<script>
import { SelectListSorted } from '../patterns'
import SvgIcon from '~/components/SvgIcon.vue'
import { getEquipmentIcon } from '~/icons/equipment'

export default {
  config: {
    title: 'Popular Features',
    weight: 20,
    facet: 'popularEquipment'
  },
  components: {
    SelectListSorted,
    SvgIcon
  },
  methods: {
    getEquipmentIcon
  }
}
</script>

<template>
  <SelectListSorted
    :facet="$options.config.facet"
    order="popularity"
    operator="AND"
  >
    <template #icon="{ value }">
      <SvgIcon :src="getEquipmentIcon(value)" />
    </template>
  </SelectListSorted>
</template>
